<template>
  <div>
    <div class="d-flex justify-center align-center" v-if="cargando">
      <v-progress-circular indeterminate color="primary" class="mb-3" size="48" />
    </div>

    <v-alert v-if="!cargando && items.length === 0" type="info" dense text class="mb-0">
      No se encontraron precios para los parámetros seleccionados.
    </v-alert>

    <v-card v-for="(tipoPrecio, idx) in items" :key="idx" outlined class="mb-3">
      <v-card-title class="py-2 px-4 grey lighten-4 d-flex align-center">
        <v-icon small color="primary" class="mr-2">mdi-tag-multiple</v-icon>
        <span class="text-subtitle-2 font-weight-bold">{{ tipoPrecio.tipoListaPrecio }}</span>
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-0">
        <template v-for="(mod, mIdx) in ordenarModalidades(tipoPrecio.modalidades)">
          <div :key="mIdx">
            <div class="d-flex align-center px-4 py-2 grey lighten-5">
              <v-chip
                x-small
                label
                :color="mod.modalidadPago === 'credito' ? 'blue lighten-4' : 'green lighten-4'"
                :text-color="mod.modalidadPago === 'credito' ? 'blue darken-2' : 'green darken-2'">
                {{ mod.modalidadPago.toUpperCase() }}
              </v-chip>
              <v-spacer />
              <span class="text-caption font-weight-bold mr-4"> Total: {{ formatearValorAMoneda(mod.total) }} </span>
              <span class="text-caption font-weight-bold orange--text text--darken-2">
                Total Mín: {{ formatearValorAMoneda(mod.totalMinimo) }}
              </span>
            </div>

            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr class="grey lighten-4">
                    <th>Concepto</th>
                    <th class="text-right">Monto Cuota / Módulo</th>
                    <th class="text-right">N° Cuotas / Módulos</th>
                    <th class="text-right">Monto</th>
                    <th class="text-right">% Desc. Máx.</th>
                    <th class="text-right">Precio Mín.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(con, cIdx) in mod.conceptos" :key="cIdx">
                    <td>{{ con.conceptoPago.nombre }}</td>
                    <td class="text-right">
                      {{ con.numeroCuotas > 0 ? formatearValorAMoneda(con.monto / con.numeroCuotas) : '—' }}
                    </td>
                    <td class="text-right">{{ con.numeroCuotas }}</td>
                    <td class="text-right font-weight-medium">{{ formatearValorAMoneda(con.monto) }}</td>
                    <td class="text-right">
                      <v-chip
                        x-small
                        label
                        :color="con.porcentajeMaximoDescuento > 0 ? 'orange lighten-4' : 'grey lighten-3'">
                        {{ con.porcentajeMaximoDescuento }}%
                      </v-chip>
                    </td>
                    <td class="text-right font-weight-bold">{{ formatearValorAMoneda(con.precioTotalMinimo) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-divider v-if="mIdx < tipoPrecio.modalidades.length - 1" />
          </div>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { formatearValorAMoneda } from '../../utils/funciones';

export default {
  name: 'TablaPreciosTodosLosTipos',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatearValorAMoneda,
    ordenarModalidades(modalidades) {
      const orden = { contado: 0, credito: 1 };
      return [...modalidades].sort((a, b) => (orden[a.modalidadPago] ?? 2) - (orden[b.modalidadPago] ?? 2));
    },
  },
};
</script>
